import React from 'react';

import { Box, BoxProps } from '@chakra-ui/react';
import { customTheme } from 'theme';

export const OrgConfigBox = (props: BoxProps) => {
  return (
    <Box
      border="1px solid"
      borderColor={customTheme.colors.gray[100]}
      borderRadius={6}
      px={4}
      pt={4}
      pb={6}
      {...props}
    ></Box>
  );
};
